import classNames from "classnames";
import React from "react";

interface ButtonProps {
  label: string | React.ReactNode;
  icon?: React.ReactNode;
  trailingIcon?: React.ReactNode;
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
  loading?: boolean;
  variant?: "outlined" | "filled" | "text" | "icon-only" | "clipped";
  /** Stable selector for QA automation. */
  testId?: string;
}

const Button: React.FC<ButtonProps> = ({
  label,
  icon,
  trailingIcon,
  onClick,
  className = "",
  disabled = false,
  variant = "outlined",
  testId,
}) => {
  const variantStyles = {
    outlined:
      "flex items-center px-3 py-2.5 w-fit bg-white text-ng-main font-semibold border-2 border-ng-main",
    filled:
      "flex items-center px-3 py-2.5 w-fit bg-ng-main text-white font-semibold border-2 border-ng-main",
    text: "flex items-center px-3 py-2.5 w-fit bg-transparent text-ng-main font-semibold border-0",
    "icon-only": "bg-transparent text-ng-main font-semibold border-0 p-0 w-fit",
    clipped:
      "flex items-center px-3 py-2.5 w-fit bg-white text-ng-main font-semibold border-2 border-ng-main bg-[#9F9F9F]! border-[#9F9F9F]! text-[#CACACA]!",
  };

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      data-testid={testId}
      className={classNames(
        "flex items-center justify-center whitespace-nowrap",
        variantStyles[variant],
        "disabled:bg-white disabled:border-[#CACACA] disabled:text-[#CACACA] disabled:cursor-not-allowed",
        className,
      )}
    >
      {icon && (
        <div
          data-testid={testId ? `${testId}-icon` : undefined}
          className="max-w-5 max-h-5 flex items-center justify-center *:max-w-full *:max-h-full"
        >
          {icon}
        </div>
      )}
      <span
        data-testid={testId ? `${testId}-label` : undefined}
        className="text-inherit"
      >
        {label}
      </span>
      {trailingIcon && (
        <div
          data-testid={testId ? `${testId}-trailing-icon` : undefined}
          className="max-w-5 max-h-5 flex items-center justify-center *:max-w-full *:max-h-full shrink-0"
        >
          {trailingIcon}
        </div>
      )}
    </button>
  );
};

export default Button;
